
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/history/cash",
      function () {
        return require("private-next-pages/history/cash/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/history/cash"])
      });
    }
  